export enum NEWS_LIST_ROW_COUNT {
  MOBILE = 5,
  DESKTOP = 15,
}
